export const fr = {
  common: {
    loading: 'Chargement…',
    error: 'Erreur de chargement',
    retry: 'Réessayer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    edit: 'Modifier',
    delete: 'Supprimer',
    confirm: 'Confirmer',
    close: 'Fermer',
    search: 'Rechercher',
    seeAll: 'Voir tout →',
    noData: 'Aucune donnée',
    seeAllResults: 'Voir tous les résultats',
    noTitle: 'Sans titre',
    unknown: 'Inconnu',
    // Temps relatif
    justNow: 'À l\'instant',
    ago: 'il y a',
    min: 'min',
    hour: 'h',
    day: 'j',
    // Formatage relatif avec interpolation (fonctions)
    relativeMin: (n) => `il y a ${n} min`,
    relativeHour: (n) => `il y a ${n}h`,
    relativeDay: (n) => `il y a ${n}j`,
    // Notifications header
    notifAgo: (n) => `Il y a ${n} min`,
    notifHoursAgo: (n) => `Il y a ${n}h`,
    notifDaysAgo: (n) => `Il y a ${Math.floor(n)}j`,
    // Temps relatif futur (pour Relances)
    inMoment: 'dans un instant',
    inMinutes: (n) => `dans ${n} min`,
    inHours: (n) => `dans ${n}h`,
    inDays: (n) => `dans ${n} jour${n > 1 ? 's' : ''}`,
  },

  sidebar: {
    ariaLabel: 'Menu principal',
    close: 'Fermer le menu',
    open: 'Ouvrir le menu',
    collapse: 'Réduire le menu',
    expand: 'Développer le menu',
    upgradePro: 'Passer au Pro',
    logout: 'Déconnexion',
    defaultUser: 'Utilisateur',
    menu: {
      dashboard: { name: 'Dashboard', description: "Vue d'ensemble" },
      agents: { name: 'Agents IA', description: 'Gestion des agents' },
      produits: { name: 'Produits', description: 'Catalogue' },
      whatsapp: { name: 'WhatsApp', description: 'Messages WhatsApp' },
      baseConnaissance: { name: 'Base de connaissances', description: 'Documentation' },
      ragChat: { name: 'Assistant IA (RAG)', description: 'Chat sur tes documents' },
      ragDocs: { name: 'Documents IA', description: 'Base RAG Gemini' },
      commandes: { name: 'Commandes', description: 'Gestion commandes' },
      caisse: { name: 'Caisse', description: 'Ventes & encaissements' },
      factures: { name: 'Factures', description: 'Devis & paiements' },
      relances: { name: 'Relances', description: 'Suivis programmés' },
      calendrier: { name: 'Calendrier', description: 'Planning' },
      parametres: { name: 'Paramètres', description: 'Configuration' },
    },
  },

  header: {
    greetingMorning: 'Bonjour',
    greetingAfternoon: 'Bon après-midi',
    greetingEvening: 'Bonsoir',
    subtitle: "Voici ce qui s'est passé aujourd'hui sur Swift AI",
    searchPlaceholder: 'Rechercher contacts, messages...',
    searching: 'Recherche en cours...',
    noResults: (q) => `Aucun résultat pour « ${q} »`,
    searchError: 'Erreur lors de la recherche',
    notifications: 'Notifications',
    markAllRead: 'Tout marquer comme lu',
    noNotifications: 'Aucune notification',
    settings: 'Paramètres',
    defaultUser: 'Utilisateur',
  },

  dashboard: {
    title: 'Tableau de bord',
    loadingText: 'Chargement du dashboard...',
    stats: {
      activeConversations: 'Conversations actives',
      today: "Aujourd'hui",
      pendingReminders: 'Relances en attente',
      inProgress: 'En cours',
      responseRate: 'Taux de réponse',
      thisMonth: 'Ce mois',
      avgResponseTime: 'Temps de réponse moyen',
      last7Days: '7 derniers jours',
      noConversation: 'Aucune conversation',
      totalConversations: (n) => `sur ${n} conversation${n > 1 ? 's' : ''} au total`,
      noReminder: 'Aucune relance active',
      remindersToProcess: 'Relances à traiter',
      noData: 'Pas encore de données',
      resolved: (r, t) => `${r} résolue${r > 1 ? 's' : ''} / ${t} total`,
      avgResponseDetail: 'Délai moy. avant 1ère réponse',
    },
    charts: {
      weeklyActivity: 'Activité hebdomadaire',
      conversationsAndReminders: 'Conversations et relances',
      conversations: 'Conversations',
      reminders: 'Relances',
      activity24h: 'Activité sur 24h',
      hourlyVolume: "Volume d'activité par heure",
      realtime: 'Temps réel',
      peak: 'Pic',
      average: 'Moyenne',
      activeHours: 'Heures actives',
    },
    recentConversations: 'Conversations récentes',
    scheduledReminders: 'Relances programmées',
    noRecentConversations: 'Aucune conversation récente',
    noScheduledReminders: 'Aucune relance programmée',
    unknownClient: 'Client inconnu',
    noMessage: 'Pas de message',
    statusWaiting: 'En attente',
    statusDone: 'Traité',
  },

  settings: {
    title: 'Paramètres',
    subtitle: 'Gérez votre compte et vos préférences',
    logout: 'Déconnexion',
    tabs: {
      profile: 'Profil',
      subscription: 'Abonnement',
      preferences: 'Préférences',
      notifications: 'Notifications',
      security: 'Sécurité',
      smsGateway: 'Passerelle SMS',
      appearance: 'Apparence',
      data: 'Données',
      help: 'Aide',
    },
    profile: {
      title: 'Informations du profil',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Email',
      emailNote: '(non modifiable)',
      saved: 'Profil mis à jour avec succès !',
      error: 'Erreur lors de la mise à jour du profil',
      avatarSuccess: 'Avatar mis à jour avec succès !',
      avatarError: "Erreur lors de l'upload de l'avatar",
    },
    subscription: {
      creditsTitle: 'Crédits IA disponibles',
      currentBalance: 'Solde actuel',
      aiCredits: 'crédits IA',
      billingTitle: 'Abonnement & facturation',
      comingSoon: 'Bientôt disponible',
      comingSoonText: "La gestion de l'abonnement sera disponible prochainement depuis votre espace. Consultez dès maintenant nos offres sur la page tarifs.",
      seePricing: 'Voir les tarifs →',
    },
    preferences: {
      title: 'Préférences générales',
      language: "Langue de l'application",
      timezone: 'Fuseau horaire',
      dateFormat: 'Format de date',
      langSuccess: 'Langue mise à jour avec succès !',
      langError: 'Erreur lors de la mise à jour de la langue',
    },
    notifications: {
      title: 'Préférences de notification',
      email: 'Email',
      emailDesc: 'Recevoir les notifications par email',
      push: 'Push',
      pushDesc: 'Notifications push sur mobile',
      sms: 'SMS',
      smsDesc: 'Alertes importantes par SMS',
      desktop: 'Desktop',
      desktopDesc: 'Notifications bureau',
      updateSuccess: 'Préférences de notification mises à jour !',
      updateError: 'Erreur lors de la mise à jour des notifications',
    },
    security: {
      title: 'Sécurité du compte',
      passwordTitle: 'Mot de passe',
      changePassword: 'Changer le mot de passe',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      currentPasswordPlaceholder: 'Entrez votre mot de passe actuel',
      newPasswordPlaceholder: 'Entrez le nouveau mot de passe',
      confirmPasswordPlaceholder: 'Confirmez le nouveau mot de passe',
      update: 'Mettre à jour',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      passwordSuccess: 'Mot de passe changé avec succès !',
      passwordError: 'Erreur lors du changement de mot de passe',
      twoFATitle: 'Authentification à deux facteurs',
      twoFAEnabled: '2FA activé',
      twoFADisabled: '2FA non activé',
      twoFAProtected: 'Votre compte est protégé par 2FA',
      twoFAAdd: 'Ajoutez une couche de sécurité supplémentaire',
      enable: 'Activer',
      disable: 'Désactiver',
      twoFADisabledSuccess: '2FA désactivé avec succès !',
      twoFAError: "Erreur lors de la gestion de l'authentification à deux facteurs",
      sessionsTitle: 'Sessions actives',
      disconnect: 'Déconnecter',
      currentSession: 'Session actuelle',
      sessionRevokeSuccess: 'Session révoquée avec succès !',
      sessionRevokeError: 'Erreur lors de la révocation de session',
    },
    smsGateway: {
      title: 'Passerelle SMS Mobile Money',
      description: "Configurez un token secret sur votre téléphone Android pour que les SMS MTN MoMo et Orange Money soient automatiquement interceptés et enregistrés dans votre caisse.",
      tokenActive: 'Token actif',
      noToken: 'Aucun token configuré',
      revoke: 'Révoquer',
      generate: 'Générer un token',
      regenerate: 'Régénérer le token',
      tokenNote: 'Token — copiez-le maintenant, il ne sera plus affiché',
      webhookUrl: "URL Webhook (à coller dans l'app Android)",
      generateSuccess: 'Token généré — copiez-le maintenant, il ne sera plus affiché.',
      generateError: 'Erreur lors de la génération du token.',
      revokeSuccess: 'Token révoqué.',
      revokeError: 'Erreur lors de la révocation.',
      revokeConfirm: "Révoquer le token ? L'app Android enverra des 401 jusqu'à reconfiguration.",
      regenerateConfirm: "Régénérer le token révoquera l'ancien. L'app Android devra être reconfigurée. Continuer ?",
      androidTitle: "Configuration de l'app Android",
      steps: [
        { t: 'Installez SMS Gateway sur votre téléphone Android (le même qui reçoit les SMS MoMo).', sub: 'App recommandée : "SMS to URL Forwarder" ou "SMS Gateway"' },
        { t: "Dans l'app, configurez l'URL Webhook ci-dessus comme URL de destination.", sub: 'Méthode : POST' },
        { t: 'Ajoutez le header personnalisé :', sub: 'X-Gateway-Token: <votre-token>' },
        { t: 'Configurez le body format JSON avec les champs :', sub: '{ "from": "{from}", "message": "{message}" }' },
        { t: 'Activez le forwarding pour tous les SMS entrants.', sub: 'Les SMS MTN MoMo et Orange Money seront automatiquement interceptés.' },
      ],
    },
    appearance: {
      title: 'Apparence',
      theme: 'Thème',
      dark: 'Sombre',
      light: 'Clair',
      auto: 'Auto',
      darkSuccess: 'Thème sombre activé !',
      lightSuccess: 'Thème clair activé !',
      autoSuccess: 'Thème automatique activé !',
      fontSize: 'Taille de police',
      small: 'Petit',
      medium: 'Moyen',
      large: 'Grand',
    },
    data: {
      title: 'Gestion des données',
      exportTitle: 'Exporter vos données',
      exportDesc: 'Téléchargez toutes vos données au format JSON',
      export: 'Exporter les données',
      exportSuccess: 'Données exportées avec succès !',
      exportError: "Erreur lors de l'export des données",
      deleteTitle: 'Supprimer le compte',
      deleteWarning: 'Attention : cette action est irréversible',
      deleteDesc: 'La suppression de votre compte entraînera la perte définitive de :',
      deleteItems: [
        'Toutes vos conversations et agents IA',
        'Vos données personnelles et préférences',
        "Votre historique d'utilisation",
        'Tous les crédits restants',
      ],
      deleteBtn: 'Supprimer mon compte',
      deleteConfirm1: 'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.',
      deleteConfirm2: 'Cette action supprimera définitivement toutes vos données. Confirmer ?',
      deleteError: 'Erreur lors de la suppression du compte',
    },
    help: {
      title: "Centre d'aide",
      faq: [
        { q: 'Comment créer un agent ?', a: 'Guide étape par étape pour créer votre premier agent IA' },
        { q: 'Configurer WhatsApp', a: 'Connecter votre compte WhatsApp Business' },
        { q: 'Gestion des crédits', a: 'Comprendre et gérer votre consommation de crédits' },
      ],
      contactSupport: 'Contacter le support',
      visitDocs: 'Visiter la documentation',
    },
  },

  agents: {
    loading: 'Chargement des agents...',
    loadError: 'Erreur lors du chargement des agents',
    deleteError: "Erreur lors de la suppression de l'agent",
    title: 'Agents IA',
    subtitle: 'Gérez vos assistants intelligents',
    create: 'Créer un agent',
    total: 'Total agents',
    active: 'Actifs',
    noAgents: 'Aucun agent créé',
    noAgentsDesc: 'Créez votre premier agent IA pour automatiser vos conversations WhatsApp',
    createFirst: 'Créer mon premier agent',
    deleteConfirmTitle: 'Supprimer cet agent ?',
    deleteConfirmDesc: (name) => `L'agent "${name}" sera définitivement supprimé.`,
    deleteConfirmBtn: 'Supprimer',
    statusActive: 'Actif',
    statusPaused: 'En pause',
    conversations: 'conversations',
    configure: 'Configurer',
    details: 'Détails',
  },

  produits: {
    loading: 'Chargement des produits...',
    loadError: 'Erreur lors du chargement des produits',
    deleteError: 'Erreur lors de la suppression',
    title: 'Produits & Services',
    subtitle: 'Gérez votre catalogue',
    catalogue: 'Catalogue',
    add: 'Ajouter un produit',
    addBtn: 'Ajouter',
    search: 'Rechercher un produit...',
    allCategories: 'Toutes catégories',
    allCat: 'Tous',
    totalProducts: 'Total produits',
    catalogValue: 'Valeur catalogue',
    totalValue: 'Valeur totale',
    categories: 'Catégories',
    available: 'Disponibles',
    sortedByPopularity: 'Triés par popularité',
    productCount: (n) => `${n} produit${n !== 1 ? 's' : ''}`,
    unlimited: 'Illimité',
    outOfStockShort: 'Rupture',
    inStockCount: (n) => `${n} en stock`,
    noProductsEmpty: 'Aucun produit',
    noProducts: 'Aucun produit trouvé',
    noProductsDesc: 'Commencez par ajouter vos premiers produits et services au catalogue',
    addFirst: 'Ajouter un produit',
    deleteConfirmTitle: 'Supprimer ce produit ?',
    deleteConfirmDesc: (name) => `Le produit "${name}" sera définitivement supprimé.`,
    deleteConfirmBtn: 'Supprimer',
    irreversible: 'Cette action est irréversible',
    willDelete: (name) => `Vous allez supprimer ${name}.`,
    viewModal: 'Voir le produit',
    editBtn: 'Modifier',
    deleteBtn: 'Supprimer',
    product: 'Produit',
    price: 'Prix',
    stock: 'Stock',
    category: 'Catégorie',
    actions: 'Actions',
    inStock: 'En stock',
    outOfStock: 'Rupture de stock',
    currency: (price) => `${price.toLocaleString('fr-FR')} XOF`,
  },

  commandes: {
    title: 'Commandes',
    subtitle: 'Gestion des commandes',
    realtime: 'Suivi de vos ventes en temps réel',
    search: 'Rechercher...',
    searchPlaceholder: 'Rechercher par client, produit ou ID...',
    all: 'Toutes',
    completed: 'Complété',
    inProgress: 'En cours',
    pending: 'En attente',
    totalOrders: 'Total Commandes',
    totalRevenue: 'Revenu Total',
    completionRate: 'Taux Complétion',
    waitingOrders: 'En Attente',
    allOrders: 'toutes commandes',
    needsAttention: 'nécessitent attention',
    completed_n: (n) => `${n} complétées`,
    thisMonth: (n) => `+${n} ce mois`,
    noOrders: 'Aucune commande trouvée',
    realtimeUpdate: 'Mise à jour en temps réel',
    orderCount: (n) => `${n} commande${n !== 1 ? 's' : ''}`,
    tableClient: 'Client',
    tableProduct: 'Produit',
    tableAmount: 'Montant',
    tableStatus: 'Statut',
    tableDate: 'Date',
  },

  factures: {
    title: 'Factures',
    subtitle: 'Devis & paiements',
    subtitleAI: 'Brouillons IA et factures manuelles',
    loading: 'Chargement des factures...',
    create: 'Nouvelle facture',
    newInvoice: 'Nouvelle facture',
    template: 'Modèle',
    search: 'Rechercher une facture...',
    searchPlaceholder: 'Rechercher par N° ou nom client...',
    all: 'Toutes',
    filterAll: 'Toutes',
    filterDraft: 'Brouillons',
    filterSent: 'Envoyées',
    filterPaid: 'Payées',
    filterOverdue: 'En retard',
    filterCancelled: 'Annulées',
    draft: 'Brouillon',
    sent: 'Envoyée',
    paid: 'Payée',
    overdue: 'En retard',
    cancelled: 'Annulée',
    pending: 'En attente',
    totalLabel: 'Total Factures',
    collected: 'Encaissé',
    draftsCount: 'Brouillons',
    toCollect: 'À encaisser',
    total: 'Total factures',
    totalAmount: 'Montant total',
    paidAmount: 'Montant encaissé',
    invoiceCount: (n) => `${n} facture${n !== 1 ? 's' : ''}`,
    noInvoices: 'Aucune facture',
    noResults: 'Aucun résultat',
    adjustFilters: "Essayez d'ajuster vos filtres",
    createFirst: "Créez votre première facture ou générez-en une depuis une commande",
    tableInvoiceNum: 'N° Facture',
    tableClient: 'Client',
    tableOrigin: 'Origine',
    tableAmount: 'Montant',
    tableStatus: 'Statut',
    tableDueDate: 'Échéance',
    tableActions: 'Actions',
    dueDate: 'Échéance',
    aiAgent: 'Agent IA',
    manual: 'Manuel',
    tooltipViewConv: 'Voir la conversation source',
    tooltipEdit: 'Éditer le brouillon',
    tooltipSend: 'Envoyer (génère PDF + lien de paiement)',
    tooltipViewPdf: 'Voir le PDF',
    tooltipWhatsApp: 'Envoyer sur WhatsApp',
    tooltipMarkPaid: 'Marquer comme payée',
    tooltipCancel: 'Annuler la facture',
  },

  relances: {
    title: 'Relances',
    titleFull: 'Relances programmées',
    subtitle: 'Suivis programmés',
    subtitleFull: "Suivis intelligents planifiés par l'IA",
    loading: 'Chargement des relances...',
    create: 'Planifier une relance',
    newRelance: 'Nouvelle relance',
    noRelances: 'Aucune relance programmée',
    noRelancesDesc: "L'agent en créera automatiquement quand un client demande à être recontacté. Vous pouvez aussi en planifier une manuellement.",
    pending: 'En attente',
    sent: 'Envoyée',
    cancelled: 'Annulée',
    failed: 'Échec',
    filterAll: 'Toutes',
    filterSent: 'Envoyées',
    filterCancelled: 'Annulées',
    filterFailed: 'Échecs',
    statTotal: 'Total',
    statSent: 'Envoyées',
    statCancelled: 'Annulées',
    searchPlaceholder: 'Rechercher par client ou raison...',
    from: 'Du',
    to: 'au',
    clearDates: 'Effacer les dates',
    tableClient: 'Client',
    tableWhen: 'Quand',
    tableReason: 'Raison',
    tableSource: 'Source',
    tableStatus: 'Statut',
    tableActions: 'Actions',
    overdueLabel: 'en retard',
    hideContext: 'Masquer le contexte',
    viewContext: 'Voir le contexte',
    hideDetails: 'Masquer les détails',
    viewDetails: 'Voir les détails',
    ai: 'IA',
    manual: 'Manuel',
    cancelConfirm: (name) => `Annuler la relance pour ${name} ?`,
    deleteConfirm: 'Supprimer définitivement cette relance ?',
    cancelSuccess: 'Relance annulée',
    cancelError: "Impossible d'annuler la relance",
    deleteSuccess: 'Relance supprimée',
    deleteError2: 'Impossible de supprimer la relance',
    createSuccess: 'Relance programmée',
    editSuccess: 'Relance reprogrammée',
    opError: "L'opération a échoué",
    toastCreated: (client, date) => `🤖 L'agent a programmé une relance pour ${client} le ${date}`,
    toastCreatedTitle: 'Nouvelle relance',
    toastSent: (client) => `Relance envoyée à ${client}`,
    toastSentTitle: 'Relance envoyée',
    errorTitle: 'Erreur',
    contextLabel: 'Contexte',
    sentMessage: 'Message envoyé',
    attempts: (n) => `Tentatives d'envoi : ${n}`,
    noDetails: 'Aucun détail supplémentaire.',
    msgUnavailable: '— (message non disponible)',
    noConv: 'Aucune conversation disponible.',
    selectConv: '— Sélectionner une conversation —',
    convLabel: 'Conversation *',
    dateLabel: 'Date et heure *',
    reasonLabel: 'Raison *',
    contextOptLabel: 'Contexte',
    optional: 'optionnel',
    contextPlaceholder: "Résumé de la situation pour aider l'agent à rédiger le message…",
    reasonPlaceholder: 'Ex: Le client souhaite réfléchir avant de commander',
    errNoConv: 'Veuillez sélectionner une conversation.',
    errNoDate: 'Veuillez choisir une date et une heure.',
    errFutureDate: 'La date de relance doit être dans le futur.',
    errNoReason: 'Veuillez indiquer une raison.',
    reschedule: 'Reprogrammer la relance',
    scheduleNew: 'Nouvelle relance',
    scheduleFor: 'Planifiez un suivi pour un client',
    rescheduleBtn: 'Reprogrammer',
    scheduleBtn: 'Programmer',
    tooltipReschedule: 'Reprogrammer',
    tooltipCancel: 'Annuler',
    tooltipDelete: 'Supprimer',
    tooltipDetails: 'Détails',
    client: 'Client',
    reason: 'Motif',
    scheduledAt: 'Planifiée le',
  },

  credits: {
    title: 'Historique des crédits',
    balance: 'Solde actuel',
    loading: 'Chargement...',
    noHistory: 'Aucune transaction',
    refill: 'Recharger',
    spent: 'Dépensé',
    added: 'Ajouté',
    date: 'Date',
    type: 'Type',
    amount: 'Montant',
    description: 'Description',
  },

};
